import React, { useEffect, Suspense } from "react";
import { useLocation } from "react-router-dom";
import Header from "../Header";
import "./about.css";
import Banner from "../../assets/about/about-us.svg";
import gradientArrow from "../../assets/about/arrows.svg";
import Credits from "../Home/Credits";
import Sales from "../Home/Sales";
import Linkedin from "../Icons/Linkedin";
import Footer from "../Footer";
import { SuspenseImg } from "../../helpers/SuspenseImg";
import MariusMobile from "../../assets/about/marius_m.png";
import MihaiMobile from "../../assets/about/mihai_m.png";
import { CONSTANTS } from "../../helpers/Constant";

const About = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      <Header />
      <section className="md:mt-16 md:mt-8 mt-14">
        <div className="bg-Gray-50 md:py-16 py-8">
          <div className="mid-container">
            <div className="container sm:container md:container lg:container w-full mx-auto">
              <div className="flex flex-col md:flex-row items-center justify-center md:justify-between">
                <div className="md:w-3/5 w-full">
                  <h2 className="md:text-3xl lg:text-5xl text-3xl leading-tight font-avenirHeavy text-Gray-900 mobile-text">
                    We build solutions{" "}
                    <span className="text-pink-500">efficiently</span>{" "}
                    <span className="inline md:block">
                      and{" "}
                      <span className="text-pink-300">cost effectively</span>
                    </span>
                  </h2>

                  <div className="md:hidden block">
                    <Suspense fallback="Loading...">
                      <SuspenseImg alt="" className="mx-auto" src={Banner} />
                    </Suspense>
                  </div>

                  <p className="font-avenirBook text-lg md:text-xl text-Gray-600 md:py-4 py-6">
                    Dynamic team with designers, developers, engineers and
                    business analysts
                  </p>
                </div>

                <div className="md:w-2/5	w-full md:block hidden">
                  <Suspense fallback="Loading...">
                    <SuspenseImg alt="" src={Banner} lassName="w-full" />
                  </Suspense>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="md:py-24 py-12">
        <div className="mid-container">
          <div className="container sm:container md:container lg:container w-full mx-auto">
            <div className="flex flex-col md:flex-row items-center justify-center md:justify-between">
              <div className="w-full md:w-6/12">
                <h3 className="text-blue-800  md:text-4xl text-3xl font-avenirHeavy">
                  Why work with us
                </h3>
                <p
                  className="text-blue-800 font-opensans font-normal text-base lg:text-2xl lg:text-xl leading-relaxed md:py-8 py-4"
                  style={{ lineHeight: "2.3rem" }}
                >
                  We turn your ambitious ideas into products people use every
                  day. Apps, platforms, virtual and augmented reality - we built
                  them well before they went mainstream. And it shows.
                </p>
                <p className="text-Gray-600 text-sm md:text-base font-normal leading-loose">
                  Since 2001, we’ve helped our customers to re-engineer,
                  digitalize, manage and operate their most essential product
                  development, advancing the ways of working that improve
                  customer experiences, heighten efficiency and lower operating
                  costs to deliver clear outcomes and topline growth. We have
                  the pleasure to work with many varying companies across a
                  couple of industries. Whether it is desktop or mobile based
                  application software, we can build it.
                </p>
              </div>
              <div className="w-full md:w-3/6 lg:w-2/6 relative text-center my-6 md:my-0">
                <img
                  src={gradientArrow}
                  alt=""
                  className="absolute z-10 -top-4 -right-6 md:-right-10"
                />
                <div className="grid grid-cols-2 md:gap-6 lg:gap-4 gap-2 grid-rows-2 relative z-50 w-full ">
                  <div className="bg-white rounded-lg shadow-xl md:py-10 py-6 flex flex-col justify-center text-center border border-Gray-150">
                    <span className="font-avenirHeavy text-blue-800 text-5xl">
                      20<span className="text-2xl">+</span>
                    </span>
                    <span className="font-avenirBook text-Gray-600">years</span>
                  </div>
                  <div className="bg-white rounded-lg shadow-xl md:py-10 py-6 flex flex-col justify-center text-center border border-Gray-150">
                    <span className="font-avenirHeavy text-blue-800 text-5xl">
                      04
                    </span>
                    <span className="font-avenirBook text-Gray-600">
                      locations
                    </span>
                  </div>
                  <div className="bg-white rounded-lg shadow-xl md:py-10 py-6 flex flex-col justify-center text-center border border-Gray-150">
                    <span className="font-avenirHeavy text-blue-800 text-5xl">
                      08
                    </span>
                    <span className="font-avenirBook text-Gray-600">
                      nationalities
                    </span>
                  </div>
                  <div className="bg-white rounded-lg shadow-xl md:py-10 py-6 flex flex-col justify-center text-center border border-Gray-150">
                    <span className="font-avenirHeavy text-blue-800 text-5xl">
                      20<span className="text-2xl">+</span>
                    </span>
                    <span className="font-avenirBook text-Gray-600">
                      employees
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="passionate-product md:py-24 py-12">
        <div className="mid-container">
          <div className="container sm:container md:container lg:container w-full mx-auto">
            <div className="flex flex-col md:flex-row items-end">
              <div className="w-full md:w-2/5 text-white text-xl md:text-3xl font-avenirHeavy">
                Great products start with passionate people.
              </div>
              <div className="w-full md:w-3/5 bg-white bg-opacity-95	py-6 px-10 rounded-lg my-6 md:my-0">
                <h3
                  className="text-Gray-900 text-xl md:text-2xl leading-relaxed font-opensans font-normal"
                  style={{ lineHeight: "2.3rem" }}
                >
                  Our professionals bring deep experience from different
                  industries, gained from hands-on expertise in various
                  functions, sectors, and locations.
                </h3>
                <p className="text-blue-800 text-sm md:text-base font-normal leading-relaxed py-5 ">
                  Our highest priority is to create best customer experience by
                  working across different skill sets, technologies and
                  locations as a cohesive team with our customers delivering
                  digital solutions that drive their business growth and
                  increase operating efficiency.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="md:pt-24 pt-12 pb-6 md:pb-12">
        <div className="mid-container">
          <div className="container sm:container md:container lg:container w-full mx-auto">
            <h3 className="text-center font-avenirHeavy md:text-4xl text-3xl text-blue-800">
              Leadership
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-8 md:pt-20 pt-10">
              <div className="bg-white rounded-lg shadow-lg border border-Gray-150 marius-profile relative">
                <div className="flex flex-row justify-between">
                  <div className="md:py-6 py-0 md:px-5 px-0 lg:w-8/12 w-full md:ml-44 ml-0">
                    <div className="relative md:hidden block">
                      <div className="flex flex-row justify-end py-5 px-5 absolute right-0 z-50">
                        <a
                          href="https://www.linkedin.com/in/sica74/"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <Linkedin className="text-Gray-900 cursor-pointer hover:text-pink-900" />
                        </a>
                      </div>
                      <img
                        src={MariusMobile}
                        alt=""
                        className="relative z-10"
                      />
                    </div>

                    <div className="flex flex-row justify-end md:flex hidden">
                      <a
                        href="https://www.linkedin.com/in/sica74/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <Linkedin className="text-Gray-900 cursor-pointer hover:text-pink-900" />
                      </a>
                    </div>
                    <div className="md:px-0 px-5 md:py-0 py-5 ">
                      <h3 className="md:text-left text-center">
                        <span className="text-black font-avenirHeavy text-2xl">
                          Marius
                        </span>{" "}
                        <span className="text-base text-Gray-600 font-avenirBook">
                          Ungureanu
                        </span>
                      </h3>
                      <span className="text-sm text-blue-800 font-light md:text-left text-center md:inline-block block">
                        CIO, Co-founder
                      </span>
                      <p className="md:text-xs text-sm text-blue-800 font-light leading-loose md:leading-4 py-5">
                        Marius is a continuous learner passionate about business
                        development and innovation, in the setting of new
                        technology. With over 20 years of IT experience, Marius
                        has a demonstrated history of creating value for
                        customers developing technical solutions with complex
                        architecture.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-white rounded-lg shadow-lg border border-Gray-150 mihai-profile relative">
                <div className="flex flex-row justify-between">
                  <div className="md:py-6 py-0 md:pl-10 md:pr-5 px-0 md:w-12/12 w-full ">
                    <div className="relative  md:hidden block">
                      <div className="flex flex-row justify-end py-5 px-5 absolute right-0 z-50">
                        <a
                          href="https://www.linkedin.com/in/mihai-bamerlind-465ab8/"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <Linkedin className="text-Gray-900 cursor-pointer hover:text-pink-900" />
                        </a>
                      </div>
                      <img src={MihaiMobile} alt="" className="relative z-10" />
                    </div>

                    <div className="flex flex-row justify-end  md:flex hidden relative z-50">
                      <a
                        href="https://www.linkedin.com/in/mihai-bamerlind-465ab8/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <Linkedin className="text-Gray-900 cursor-pointer hover:text-pink-900" />
                      </a>
                    </div>

                    <div className="md:px-0 px-5 md:py-0 py-5 md:w-8/12 w-full">
                      <h3 className="md:text-left text-center">
                        <span className="text-black font-avenirHeavy text-2xl">
                          Mihai
                        </span>{" "}
                        <span className="text-base text-Gray-600 font-avenirBook">
                          Bamerlind
                        </span>
                      </h3>
                      <span className="text-sm text-blue-800 font-light md:text-left text-center md:inline-block block">
                        CEO, Co-founder
                      </span>
                      <p className="md:text-xs text-sm text-blue-800 font-light leading-loose md:leading-4 py-5">
                        Mihai is an entrepreneur and business developer with
                        passion for IT. He has many years of experience in the
                        automotive industry and is a senior systems architect
                        with more than 15 years of experience from various roles
                        and deliveries in IT. Mihai founded{" "}
                        {CONSTANTS.COMPANY_NAME} in 2001 together with Marius.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Credits />
      <section className="bg-Gray-50">
        <Sales title="Let’s build together." />
      </section>
      <Footer />
    </>
  );
};

export default About;
